import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './AnimatedTopbar.css'; // Import the CSS file
// import { Link } from 'lucide-react';
import { Link } from 'react-router-dom';

function AnimatedTopbar() {
  // Array of announcements - will be admin-controlled later
  const announcements = [
    {
      text: "Free UK Shipping Over $45",
      link: null
    },
    {
      text: "Get 10% off. ",
      linkText: "Sign-up now here",
      link: "/signup"
    },
    {
      text: "See our new incredible arrivals",
      link: "/new-arrivals"
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => 
        (prevIndex + 1) % announcements.length
      );
    }, 4000); // Change every 4 seconds

    return () => clearInterval(interval);
  }, [announcements.length]);

  const currentAnnouncement = announcements[currentIndex];

  return (
    <div className="topbar">
      
      <AnimatePresence mode="wait">
        <motion.div
          key={currentIndex}
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.5 }}
          className="plate"
        >
          {currentAnnouncement.link ? (
            <a href={currentAnnouncement.link} className="announcement-link">
              {currentAnnouncement.text}
              {currentAnnouncement.linkText && (
                <span className="link-text">{currentAnnouncement.linkText}</span>
              )}
            </a>
          ) : (
            <span>{currentAnnouncement.text}</span>
          )}
        </motion.div>
      </AnimatePresence>

      {/* Navigation dots */}
      <div className="announcement-dots">
        {announcements.map((_, index) => (
          <button
            key={index}
            className={`dot ${index === currentIndex ? 'active' : ''}`}
            onClick={() => setCurrentIndex(index)}
            aria-label={`Go to announcement ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
}

export default AnimatedTopbar;